var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE__frontend_taglib_clay_liferay_exports_clay_icon_js_25931ae2__;